var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFolder = function SvgIconFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.45 6.5h7.8A1.75 1.75 0 0 1 22 8.25v10.584a1.665 1.665 0 0 1-1.666 1.666H3.694A1.694 1.694 0 0 1 2 18.806V4.875a1.75 1.75 0 0 1 1.75-1.75h4.912a1.75 1.75 0 0 1 1.311.59h.001zM8.475 5.04v.002zm.075.085L9.773 6.5H4V5.125zM4 8.5v10h16v-10z",
    clipRule: "evenodd"
  })));
};
export default SvgIconFolder;